import { useParams } from "react-router-dom";
import OrganisationsPage from "./OrganisationsPage.jsx";
import JoinTeamPage from "./JoinTeamPage.jsx";
import InternshipsPage from "./InternshipsPage.jsx";
import NotFoundPage from "./NotFoundPage.jsx";

/* Keeps the legacy /student-opportunities/:category URL pattern. Unknown slugs get the 404 page. */
const PAGES = {
  organisations: OrganisationsPage,
  team: JoinTeamPage,
  internships: InternshipsPage,
};

export default function OpportunityCategoryPage() {
  const { category } = useParams();
  const Page = PAGES[category];
  return Page ? <Page /> : <NotFoundPage />;
}
